<template>
  <router-link :to="'/items/vatpham/' + vatpham.id">
    <img
      :src="base_url + item.image"
      class="card-img-top"
      alt="">
    <div class="card-body">
      <h5 class="card-title">{{ item.name }}</h5>
      <p class="card-text"><rating/><span>{{ item.nr_view }}</span></p>
    </div>
  </router-link>
</template>

<script>
    import ApiConfig from '../../communicate/ApiConfig'
    import rating from '../include/rating'
    export default {
        name: "ItemsService",
        components: {
            rating: rating
        },
        props: ['item'],
        data: function() {
            return {
                base_url: ApiConfig.base_url
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/item/ItemsService.vue